export default __webpack_public_path__ + "static/media/hmd_s3.6fa7cb52.png";